import { breakpointSizes, Container } from "@brightagency/headstart-common";
import DevicesOutlined from "@mui/icons-material/DevicesOutlined";
import MedicalServicesOutlined from "@mui/icons-material/MedicalServicesOutlined";
import ThreePOutlinedIcon from '@mui/icons-material/ThreePOutlined'
import React, { FC, ReactNode } from "react";
import { useGlobalElements } from "../../../services/app-state";
import { Grid, GridBreakpoints } from "../../molecules/Grid";
import { OtherSupportTile } from "./OtherSupportTile";
import { Wrapper, Inner, Title } from "./styled";

const iconToColumnIndexMapping: Record<number, ReactNode> = {
    0: <MedicalServicesOutlined htmlColor="white" />,
    1: <ThreePOutlinedIcon htmlColor="white" />,
    2: <DevicesOutlined htmlColor="white" />,
};

export const OtherSupport: FC = () => {
    const [{ other_support }] = useGlobalElements();

    const gridBreakpoints: GridBreakpoints = [
        { breakpointWidth: 0, columns: 1, gutter: 48 },
        { breakpointWidth: breakpointSizes.large, columns: 3, gutter: 30 },
    ];

    return (
        <Wrapper>
            <Inner>
                <Container>
                    <Title>{other_support.title}</Title>
                    <Grid breakpoints={gridBreakpoints}>
                        {other_support.columns.map((data, index) => (
                            <OtherSupportTile
                                key={data.title}
                                {...data}
                                icon={iconToColumnIndexMapping[index]}
                            />
                        ))}
                    </Grid>
                </Container>
            </Inner>
        </Wrapper>
    );
};
